// @ts-nocheck
/**
  * @param {Object} el - A DOM element
  *
  * @returns {Array} elements - The scrollable containers the given element is within
  */
export function getScrollParents(el) {
  const computedStyle = window.getComputedStyle(el) || {};
  const { position } = computedStyle;
  const parents = [];

  if (position === 'fixed') {
    return [el];
  }

  let parent = el;

  while ((parent = parent.parentNode) && parent && parent.nodeType === 1) {
    let style = null;

    try {
      style = window.getComputedStyle(parent);
    } catch (err) {
      // nothing
    }

    if (typeof style === 'undefined' || style === null) {
      parents.push(parent);
      return parents;
    }

    const { overflow, overflowX, overflowY } = style;

    if (/(auto|scroll|overlay)/.test(overflow + overflowY + overflowX)) {
      if (position !== 'absolute' || ['relative', 'absolute', 'fixed'].indexOf(style.position) >= 0) {
        parents.push(parent);
      }
    }
  }

  parents.push(el.ownerDocument.body);

  // If the node is within a frame, account for the parent window scroll
  if (el.ownerDocument !== document) {
    parents.push(el.ownerDocument.defaultView);
  }

  return parents;
}
